import { render, staticRenderFns } from "./delivery-werner.vue?vue&type=template&id=48ea1202"
import script from "./delivery-werner.vue?vue&type=script&lang=js"
export * from "./delivery-werner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports